import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { constants } from '../../constants/constants';
import { ClientLoginDetails, ConsolidatedLoginBenefits, Participant } from '@edassist/api';
import { ADDRESS_TYPES } from '../../enums/participant/address-types.enum';

@Injectable({ providedIn: 'root' })
export class ParticipantUtilityService {
	static getParticipantId(): number {
		return LocalStorageService.getItem(constants.localStorageKeys.CURRENT_USER)?.participantId;
	}

	static getUserId(): number {
		return LocalStorageService.getItem(constants.localStorageKeys.CURRENT_USER)?.userId;
	}

	static userTypeId(): number {
		return LocalStorageService.getItem(constants.localStorageKeys.CURRENT_USER)?.userTypeId;
	}

	static getClientLoginDetails(): ClientLoginDetails {
		return LocalStorageService.getItem(constants.localStorageKeys.CLIENT_DETAILS);
	}

	static getConsolidatedLoginBenefits(): Array<ConsolidatedLoginBenefits> {
		return LocalStorageService.getItem(constants.localStorageKeys.CLIENT_DETAILS)?.consolidatedLoginBenefits;
	}

	static getConsolidatedLoginUserId(): string {
		return LocalStorageService.getItem(constants.localStorageKeys.CURRENT_USER_HYBRID)?.userDetails
			?.consolidatedLoginUserId;
	}

	static getParticipantPreferredEmail(participant: Participant): string {
		switch (participant.preferredEmail) {
			case ADDRESS_TYPES.HOME:
				return participant.homeAddress?.email;
			case ADDRESS_TYPES.WORK:
				return participant.workAddress.email;
			case ADDRESS_TYPES.OTHER:
				return participant.otherEmail;
			default:
				return '';
		}
	}

	static getPreferredPhone(participant: Participant): string {
		switch (participant.preferredPhone) {
			case ADDRESS_TYPES.HOME:
				return participant.homeAddress?.phone;
			case ADDRESS_TYPES.WORK:
				return participant.workAddress.phone;
			case ADDRESS_TYPES.OTHER:
				return participant.otherPhone;
			default:
				return '';
		}
	}

	static getAddressIdFromAddressType(participant: Participant, addressType: string): number {
		switch (addressType) {
			case constants.ADDRESS_TYPES.HOME:
				return participant.homeAddressId;
			case constants.ADDRESS_TYPES.WORK:
				return participant.workAddressId;
			default:
				return participant.homeAddressId;
		}
	}
}
